import React, { useContext, useState } from 'react'
import { IoClose } from 'react-icons/io5'
import Select from 'react-select'
import { toast } from 'react-toastify'
import { Auth } from '../../../contexts/allContext'
import { useRequest } from '../../../hooks/useRequest'
import { getLocalDateTime } from '../../../utils/localTime'
import { orderStatus, paymentStatus, shipmentStatus } from '../../../utils/static/static'
import PopupV1 from '../../Resources/PopupV1/PopupV1'
import classes from './StatusPopup.module.css'

export default function StatusPopup({ setForm, form, updateProductStatus, statusToggle, setStatusToggle }) {
    const { Order, OrderShipment } = updateProductStatus
    const { stateAuth } = useContext(Auth)
    const token = stateAuth.token
    const { handleSubmit } = useRequest()

    const [status, setStatus] = useState({
        shipment: '',
        payment: '',
        order: '',
        orderId: Order?.id || '',
    })

    const handleSelectChange = (label, value) => {
        setStatus((prev) => ({
            ...prev,
            [label]: value,
            orderId: Order?.id,
        }))
    }

    const submitAllStatuses = async () => {
        const userToken = stateAuth?.token
        const orderId = Order?.id

        if (!orderId || !userToken) return

        const newOrderStatus = status.order || Order?.order_status
        const oldOrderStatus = Order?.order_status

        const payload = {
            shipment_status: status.shipment || OrderShipment?.shipment_status,
            payment_status: status.payment || Order?.payment_status,
            order_status: newOrderStatus,
        }

        const statusRemarksMap = {
            pending: 'Order has been placed and is awaiting processing',
            processing: 'Order is now being processed',
            in_transit: 'Order is currently in transit',
            delivered: 'Order has been successfully delivered',
            returned: 'Order has been returned',
            cancelled: 'Order has been cancelled',
        }

        try {
            const { data, isSuccess } = await handleSubmit(
                `v2/orders/status/${orderId}`,
                '',
                payload,
                userToken,
                'PATCH'
            )

            if (isSuccess) {
                if (newOrderStatus !== oldOrderStatus) {
                    const summaryPayload = {
                        status: newOrderStatus,
                        datetime: getLocalDateTime(),
                        remarks: statusRemarksMap[newOrderStatus],
                        order_id: orderId,
                    }

                    await handleSubmit(`v2/orders/status/summaries`, '', summaryPayload, userToken, 'POST')
                }

                setStatusToggle(!statusToggle)
                toast.success(`Status updated successfully`)
                setForm(false)
            }
        } catch (error) {
            console.error('Failed to update statuses:', error)
            toast.error('Failed to update statuses')
        }
    }

    return (
        <div className={classes.container}>
            <PopupV1 setForm={setForm} form={form} width="34%">
                <div className={classes.close}>
                    <div className={classes.closeIcon}>
                        <p onClick={() => setForm(!form)}>
                            <IoClose size={20} />
                        </p>
                    </div>
                    <div className={classes.header}>
                        <p>Update Product Status</p>
                    </div>
                </div>
                <div className={classes.dropDown}>
                    {/* <p className={classes.customDropDown}>
                        <label htmlFor="shipment" className={classes.label}>
                            Delivery Status
                        </label>
                        <Select
                            inputId="shipment"
                            options={shipmentStatus}
                            classNamePrefix="react-select"
                            defaultValue={shipmentStatus.find((s) => s.value === OrderShipment?.shipment_status)}
                            onChange={(selectedOption) => handleSelectChange('shipment', selectedOption.value)}
                        />
                    </p> */}

                    <p className={classes.customDropDown}>
                        <label htmlFor="order" className={classes.label}>
                            Order Status
                        </label>
                        <Select
                            inputId="order"
                            options={orderStatus}
                            classNamePrefix="react-select"
                            defaultValue={orderStatus.find((s) => s.value === Order?.order_status)}
                            onChange={(selectedOption) => handleSelectChange('order', selectedOption.value)}
                        />
                    </p>

                    <p className={classes.customDropDown}>
                        <label htmlFor="payment" className={classes.label}>
                            Payment Status
                        </label>
                        <Select
                            inputId="payment"
                            options={paymentStatus}
                            classNamePrefix="react-select"
                            defaultValue={paymentStatus.find((s) => s.value === Order?.payment_status)}
                            onChange={(selectedOption) => handleSelectChange('payment', selectedOption.value)}
                        />
                    </p>
                </div>

                <div className={classes.buttonContainer}>
                    <button className={classes.submitButton} onClick={submitAllStatuses}>
                        Submit
                    </button>
                </div>
            </PopupV1>
        </div>
    )
}
